import { css } from '@emotion/react'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
// import 'react-table/react-table.css'
import('assets/react_select_search.css')

import Fonts from './fonts'

const GlobalStyle = css`
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	html,
	body,
	#app {
		height: 100%;
		width: 100%;
	}

	html {
		background-color: rgb(var(--app-bg, 255 255 255));
		color: rgb(var(--app-text, 15 23 42));
		color-scheme: light;
	}

	html[data-color-mode='dark'] {
		color-scheme: dark;
	}

	body {
		font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		background-color: inherit;
		color: inherit;
	}

	#app {
		min-height: 100%;
		min-width: 100%;
	}

	input,
	select {
		font-family: inherit;
		font-size: inherit;
	}

	${Fonts.BalletHarmony}
`

export const LightTheme = createMuiTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#2e7d32',
		},
		secondary: {
			main: '#dc0409',
		},
	},
})

export const DarkTheme = createMuiTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#3fb346',
			light: 'rgb(44, 125, 49)',
		},
		secondary: {
			main: '#d61e23',
		},
	},
})

export function createAppTheme({ mode = 'light', primary_main, secondary_main }) {
	const is_dark = mode === 'dark'

	return createMuiTheme({
		palette: {
			mode,
			background: {
				default: is_dark ? '#0f1115' : '#ffffff',
				paper: is_dark ? '#161b22' : '#ffffff',
			},
			text: {
				primary: is_dark ? '#e5e7eb' : '#0f172a',
				secondary: is_dark ? '#9ca3af' : '#64748b',
			},
			divider: is_dark ? 'rgba(226, 232, 240, 0.20)' : 'rgba(15, 23, 42, 0.12)',
			primary: {
				main: primary_main,
			},
			secondary: {
				main: secondary_main,
			},
		},
	})
}

export default GlobalStyle
